import React from "react";
import ModalCreatePrecandidate from "../create/ModalCreatePrecandidate";
import { usePrecandidateContext } from "../context/Context";
import { useTranslation } from "react-i18next";
import { useGeneralContext } from "../../General/Context";
import  PersonIcon  from "../../../layout/left_menu_icons/person.svg";
import "../../styles/header.scss";

const HeaderPreCandidate = () => {
  const {
    setPrecandidate,
    LoadManagers,
    modalShow,
    setModalShow
  } = usePrecandidateContext();
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();

  return (
    <header className="page-header">
      <div className="header-title">
        <div className="title">
          <img src={PersonIcon} alt="pc-icon" />
          <h1 style={{marginTop:"10px"}}>{t("Pre-Candidates")}</h1>
        </div>
        <div className="subtitle">{t("Recruitment / Pre-Candidates")}</div>
      </div>
      {userInformation.permissions.Create_Edit_PreCand && (
        <button
          className="app-button btn-prime btn-lg"
          id="buttonCreatePreCandidate"
          onClick={() => {
            setModalShow(true);
            setPrecandidate({});
            LoadManagers();
          }}
        >
          {t("+ New Pre-Candidate")}
        </button>
      )}
      
      <ModalCreatePrecandidate showCreateModal={modalShow} />
    </header>
  );
};

export default HeaderPreCandidate;
